import { render, staticRenderFns } from "./postSetting.vue?vue&type=template&id=df42a986&scoped=true&"
import script from "./postSetting.vue?vue&type=script&lang=js&"
export * from "./postSetting.vue?vue&type=script&lang=js&"
import style0 from "./postSetting.vue?vue&type=style&index=0&id=df42a986&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df42a986",
  null
  
)

export default component.exports